import { IRunwayInfo } from "../../../../utils/maps/MapConstants";
import {
  isValidCoordinate,
  toLatLng,
} from "../../../../utils/maps/MapHelperFunctions";
import RSCMarker from "./RSCMarker";

export interface IRunwayRsc {
  current: IRunwayInfo;
  prior: IRunwayInfo;
}

export interface IRunway {
  name: string;
  id: string;
  status: string;
  remarks?: string;
  startLocation: [number | string, number | string];
  endLocation: [number | string, number | string];
  rsc: IRunwayRsc;
}

export interface IRunwayMarkersProps {
  airportCode: string;
  runwayData: IRunway[];
}

const RunwayMarkers: React.FC<IRunwayMarkersProps> = ({
  airportCode,
  runwayData,
}) => {
  if (!runwayData.length) {
    return null;
  }

  return (
    <>
      {runwayData.map((runway: IRunway) => {
        if (
          !isValidCoordinate(runway.startLocation) ||
          !isValidCoordinate(runway.endLocation)
        ) {
          return null;
        }
        return (
          <RSCMarker
            key={runway.id}
            airportCode={airportCode}
            runwayName={runway.name}
            start={toLatLng(runway.startLocation)}
            end={toLatLng(runway.endLocation)}
            rscInfo={runway.rsc}
            status={[
              runway.rsc.current?.segments[0]?.status,
              runway.rsc.current?.segments[1]?.status,
              runway.rsc.current?.segments[2]?.status,
            ]}
          />
        );
      })}
    </>
  );
};

export default RunwayMarkers;
